const normalFont = `"Open Sans", "Noto Sans SC", "Noto Sans TC", Arial, Helvetica, sans-serif, 微軟正黑體, "Segoe UI", "Helvetica Neue", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
const loraFont = `"Lora", serif, 'Noto Serif SC', 'Noto Serif TC', ${normalFont}`;

const processSize = (size) => {
  let number = 0;
  switch (size) {
    case "ss":
      number = 374;
      break;
    case "xs":
      number = 479;
      break;
    case "sm":
      number = 575;
      break;
    case "md":
      number = 767;
      break;
    case "lg":
      number = 991;
      break;
    case "xl":
      number = 1199;
      break;
    case "xxl":
      number = 1599;
      break;
    default:
      number = size;
  }
  return number;
};

const rwdMobile = (size, content) => {
  let pixel = processSize(size) + "px";
  const string = `
    @media only screen and (max-width: ${pixel} ) {
      ${content}
    }
  `;

  return string;
};

const rwdDesktop = (size, content) => {
  let pixel = processSize(size) + 1 + "px";
  const string = `
    @media only screen and (min-width: ${pixel} ) {
      ${content}
    }
  `;
  return string;
};

export { normalFont, loraFont, rwdMobile, rwdDesktop };
